import React from 'react';
import { ButtonV2 } from '@withjoy/joykit';
import { AddCircle } from '@withjoy/joykit/icons';
import { ContactInputFields, newMember } from '@apps/contactCollector/guest/ContactCollectorGuest.controller';

interface AddMemberProps
  extends Readonly<{
    push: (obj: ContactInputFields) => void;
    title: string;
  }> {}

export const AddMember: React.FC<AddMemberProps> = ({ push, title }) => (
  <ButtonV2 startIcon={AddCircle} variant="ghost" paddingLeft={0} justifyContent="flex-start" margin="26px 0 10px" onClick={() => push(newMember)}>
    {title}
  </ButtonV2>
);
